import { Grid } from "@mui/material";
import React from "react";
import { DetailInputsModalProps } from "../../../components/ModalExtractContent/ModalExtractContent";
import TitleAndDetailExtract from "../../../components/ModalExtractTitleAndDetail/ModalExtractTitleAndDetail";

interface ModalOrderDetailsContentProps {
  productName: DetailInputsModalProps;
  modality: DetailInputsModalProps;
  quantity: DetailInputsModalProps;
  payment?: DetailInputsModalProps;
  type?: DetailInputsModalProps;
  color?: string;
  borderWidth?: number;
}

const ModalOrderDetailsContent: React.FC<ModalOrderDetailsContentProps> = ({
  productName,
  modality,
  quantity,
  payment,
  type,
  color,
  borderWidth = 0,
}) => {
  return (
    <Grid
      container
      sx={{
        border: borderWidth,
        borderStyle: "solid",
        borderColor: "shadesOfDark.ultraLight",
        borderRadius: "4px",
      }}
      padding={2}
      paddingTop={1}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          display={"flex"}
          justifyContent={"left"}
        >
          <TitleAndDetailExtract
            color={color}
            title={productName.title}
            detail={productName.value}
            textAlign={"left"}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={3}
          md={4}
          display={"flex"}
          justifyContent={"left"}
        >
          <TitleAndDetailExtract
            color={color}
            title={modality.title}
            detail={modality.value}
            textAlign={"left"}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={3}
          md={3}
          display={"flex"}
          justifyContent={"right"}
        >
          <TitleAndDetailExtract
            color={color}
            title={quantity.title}
            detail={quantity.value}
            textAlign={"right"}
          />
        </Grid>
        {payment !== undefined && type !== undefined && (
          <>
            <Grid
              item
              pt={2}
              xs={12}
              sm={6}
              md={5}
              display={"flex"}
              justifyContent={"left"}
            >
              <TitleAndDetailExtract
                color={color}
                title={payment.title}
                detail={payment.value}
                textAlign={"left"}
              />
            </Grid>
            <Grid
              item
              pt={2}
              xs={12}
              sm={6}
              md={4}
              display={"flex"}
              justifyContent={"left"}
            >
              <TitleAndDetailExtract
                color={color}
                title={type.title}
                detail={type.value}
                textAlign={"left"}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default ModalOrderDetailsContent;
